import * as React from "react";
import * as moment from "moment";
import 'moment/locale/it';

import { bindToApp } from "src/services/api";
import { Notification, notifyListener, Alert } from "src/services/notify";
moment.locale('it');

interface Props {
}

interface State {
  notification?: Notification | null
  notificationActive?: boolean;
  alert?: Alert | null
}

var timers = {} as any;
class App extends React.Component<Props, State> {
  state = {} as State;
  
  constructor(props) {
    super(props);
    bindToApp(this);
    notifyListener(this);
  }
  
  gotResponse( res ) {
    const { status_code, data, message, messages, errors } = res.data;
    if (status_code.toString().substr(0,1) === "2") {
      
    } else {
      this.notificationPut({
          type: 'error',
          text: message
      });
    }
  }
  
  notificationPut( notification ) {
    this.setState({
      notification
    });
    setTimeout( () => {
      this.setState( { notificationActive: true } );
    }, 1 );
    if (timers && timers.close) {
      clearTimeout(timers.close);
    }
    timers.close = setTimeout( () => {
      this.notificationShut();
    }, 10000 );
  }
  
  notificationShut() {
    this.setState( { notificationActive: false } );
    setTimeout( () => {
      this.setState({
        notification: null
      });
    }, 300 );
  }

  alertPut( alert ) {
    this.setState({
      alert
    });
  }
  
  alertShut() {
    this.setState( { alert: null } );
  }
  
  render() {
    const { children } = this.props;
    const { notification, notificationActive, alert } = this.state;
    
    return (
      <>
        {children}
        {notification &&
        <article className={`notification ${notificationActive ? 'active' : null} ${notification.type || 'success'}`}>
          <span className="icon-close" onClick={() => this.notificationShut()}></span>
          <div>
          { notification.text }
          </div>
        </article>
        }
        {alert &&
        <article className={`ui-alert ${alert.type || 'success'}`} onClick={() => this.alertShut()}>
          <div>
            {alert.title &&
            <header>{alert.title}</header>
            }
            <div dangerouslySetInnerHTML={{__html: alert.text }} />
            {alert.buttons &&
            <footer>
              {alert.buttons.map( (btn, k) => (
              <span key={k}><button className={`${btn.type}`} onClick={() => { if (btn.cb) btn.cb() } }><span>{btn.label}</span></button></span>
              ))}
            </footer>
            }
          </div>
        </article>
        }
      </>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.tsx